import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { RevenuePerPlayerDto } from '../../../models/analytics/dto/get-revenue-per-player.dto';

export const GET_REVENUE_PER_PLAYER_QUERY_KEY = 'revenuePerPlayer';

export const useGetRevenuePerPlayer = (
    locationId: string | undefined,
    startDate?: Date,
    endDate?: Date,
    limit = 10,
) => {
    const apiClient = useApiClient();
    return useQuery<RevenuePerPlayerDto>({
        queryKey: [GET_REVENUE_PER_PLAYER_QUERY_KEY, locationId, startDate, endDate, limit],
        queryFn: async () => {
            const dateSuffix =
                startDate && endDate
                    ? `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`
                    : '';
            return apiClient.fetchApi<RevenuePerPlayerDto, {}>({
                method: 'GET',
                endpoint: `analytics/revenue-per-player?locationId=${locationId}&limit=${limit}${dateSuffix}`,
            });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
};
